// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Outlook Calendar style mark, drawn to sit beside OutlookLogo and TeamsLogo.

import type React from 'react';

interface OutlookCalendarLogoProps {
	size?: number;
	style?: React.CSSProperties;
}

export function OutlookCalendarLogo({size = 16, style}: OutlookCalendarLogoProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 32 32"
			fill="none"
			aria-hidden="true"
			style={{flexShrink: 0, ...style}}
		>
			<rect x="3" y="4" width="26" height="25" rx="4" fill="#0F6CBD" />
			<rect x="3" y="4" width="26" height="8" rx="4" fill="#1B8CE0" />
			<rect x="3" y="9" width="26" height="3" fill="#1B8CE0" />
			<rect x="9" y="2" width="3" height="6" rx="1.5" fill="#0B4F8F" />
			<rect x="20" y="2" width="3" height="6" rx="1.5" fill="#0B4F8F" />
			<rect x="7.5" y="15" width="4" height="4" rx="1" fill="white" />
			<rect x="14" y="15" width="4" height="4" rx="1" fill="white" />
			<rect x="20.5" y="15" width="4" height="4" rx="1" fill="white" opacity="0.7" />
			<rect x="7.5" y="21" width="4" height="4" rx="1" fill="white" opacity="0.7" />
			<rect x="14" y="21" width="4" height="4" rx="1" fill="#7CC5FF" />
			<rect x="20.5" y="21" width="4" height="4" rx="1" fill="white" opacity="0.7" />
		</svg>
	);
}
